import React, { useRef, useEffect } from 'react';
import classNames from 'classnames';

import { IMap } from 'common/utils/Map/types/map';
import { MapMarkerLayer } from 'common/utils/MapMarker';
import {
  Params as RouteConstructorParams
} from 'common/utils';

import { Controls } from './Controls';
import Footer from './Footer';
import { MapTypeSwitcher } from './MapTypeSwitcher/MapTypeSwitcher';

import { useMediaQuery } from 'common/hooks';
import useMapStyles from './hooks/useMapStyles';
import useGlobalStyles from './useGlobalStyles';
import {
  useInitMap,
  useUpdateFocusPoint,
  useMapMarkerLayers
} from './hooks';
import {
  useShowStreetView,
  useMapOperations
} from 'entities/map';

import { useMapContext } from 'entities/map';

import { FooterElements } from './types/footerElements';

import useStyles from './useStyles';
export interface Props {
  showZoomControl?: boolean;
  onInitializedMap?: (map: IMap) => void;
  routeInitData?: RouteConstructorParams;
  styles?: React.CSSProperties;
  footerElements?: FooterElements;
  showStationsDisplayButton?: boolean;
  layers?: MapMarkerLayer[];
  showMapTypeControl?: boolean;
};

const Map = ({
  showZoomControl = true,
  styles,
  onInitializedMap,
  footerElements,
  showStationsDisplayButton = false,
  layers,
  showMapTypeControl = true
}: Props) => {
  const { setShowStreetView } = useMapOperations();

  const showStreetView = useShowStreetView();
  const classes = useStyles({ showStreetView });
  const containerRef = useRef<HTMLDivElement>(null);
  const mapStyles = useMapStyles(styles);
  const { isMobile } = useMediaQuery();

  useInitMap(containerRef, onInitializedMap);
  useMapMarkerLayers(layers);
  useUpdateFocusPoint();
  useGlobalStyles();

  const { addListenerStreetViewChange, map } = useMapContext();

  useEffect(() => {
    addListenerStreetViewChange(setShowStreetView);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map]);

  return (
    <>
       <Controls
        showZoomControl={showZoomControl}
        showMapTypeControl={showMapTypeControl}
      />
      <Footer
        footerElements={footerElements}
        showStationsDisplayButton={showStationsDisplayButton}
      />
      <div
        id="map"
        ref={containerRef}
        style={mapStyles}
        className={classNames({
          [classes.map]: true,
          [classes.gmStyle]: showZoomControl
        })}
        onClick={(event: any) => {
          event.stopPropagation();
        }}
      />
      {!isMobile && <MapTypeSwitcher show={showMapTypeControl} />}
    </>
  );
};

export default Map;
